import styled, { css } from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

/** Dashed dropzone (default) — fills the area; brightens while dragging over. */
export const Dropzone = styled.label<{ $variant: 'desktop' | 'mobile'; $dragging: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
  height: ${({ $variant }) => ($variant === 'desktop' ? '246px' : '180px')};
  padding: 24px;
  border: 1.5px dashed ${({ $dragging }) => ($dragging ? CUST.accent : CUST.cardBorder)};
  border-radius: 22px;
  cursor: pointer;
  background-image: ${CUST_GRADIENTS.panel};
  transition:
    border-color ${CUST_ANIM.INTERACT_MS}ms ease,
    filter ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    filter: brightness(1.08);
  }

  ${({ $dragging }) =>
    $dragging &&
    css`
      filter: brightness(1.12);
    `}
`;

export const DropIcon = styled.span`
  display: inline-flex;
  color: ${CUST.dropzoneText};
`;

export const DropText = styled(Text)`
  font-size: 14px;
  color: ${CUST.dropzoneText};
`;

/** Preview plate (after upload) — frames the uploaded logo; click to re-upload.
 *  `$frame` flips the backing for contrast against the logo's own luminance
 *  (light mark → dark plate, dark mark → light plate); see `useLogoFrame`. */
export const Preview = styled.label<{ $variant: 'desktop' | 'mobile'; $frame: 'light' | 'dark' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ $variant }) => ($variant === 'desktop' ? '246px' : '180px')};
  padding: 24px;
  border: 1px solid ${CUST.cardBorder};
  border-radius: 22px;
  background: ${({ $frame }) => ($frame === 'light' ? CUST.logoFrameLight : CUST.logoFrameDark)};
  overflow: hidden;
  cursor: pointer;
  transition: background-color ${CUST_ANIM.INTERACT_MS}ms ease;
`;

export const PreviewImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const PreviewWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

/** "Upload another logo" — re-opens the picker (a label for the same input). */
export const Reupload = styled.label`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${CUST.accentText};
  cursor: pointer;
`;

export const ReuploadLabel = styled(Text)`
  font-size: 14px;
  color: ${CUST.accentText};
  white-space: nowrap;
`;